import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import {
  Box,
  IconButton,
  List,
  ListItemButton,
  ListItemText,
  Paper,
  Tooltip,
  Typography,
} from '@mui/material';
import RefreshIcon from '@mui/icons-material/Refresh';
import React, {useEffect, useState} from 'react';
import {getRecentPlayers} from '../utils/PlayerApi';
import {useLoading} from '../../loading-overlay/LoadingContext';
import PropTypes from 'prop-types';

export default function RecentPlayers({onSelected}) {
  const maxRecentPlayerPages = 3;

  const {addToLoading} = useLoading();

  const [selectedPlayerIndex, setSelectedPlayerIndex] = useState(-1);
  const [recentPlayers, setRecentPlayers] = useState([]);
  const [loadedRecentPlayerPages, setLoadedRecentPlayerPages] = useState(0);

  async function fetchInitialRecentPlayers() {
    const updatedRecentPlayers = await getRecentPlayers();
    setSelectedPlayerIndex(-1);
    setRecentPlayers(updatedRecentPlayers);
    setLoadedRecentPlayerPages(0);
  }

  useEffect(() => {
    addToLoading(fetchInitialRecentPlayers());
  }, []);

  async function fetchMoreRecentPlayers() {
    const moreRecentPlayers = await getRecentPlayers(loadedRecentPlayerPages + 1);
    setRecentPlayers((currentRecentPlayers) => [...currentRecentPlayers, ...moreRecentPlayers]);
    setLoadedRecentPlayerPages((loadedRecentPlayerPages) => loadedRecentPlayerPages + 1);
  }

  const handlePlayerListItemClick = (event, index) => {
    setSelectedPlayerIndex(index);
    onSelected(recentPlayers[index]);
  };

  return (
    <Paper
      sx={{
        minWidth: {xs: '40vw', md: '30vw'},
        maxWidth: {xs: '45vw', md: '35vw'},
        margin: 'auto',
        overflow: 'hidden',
      }}
    >
      <AppBar
        position="static"
        color="default"
        elevation={0}
        sx={{borderBottom: '1px solid rgba(0, 0, 0, 0.12)'}}
      >
        <Toolbar>
          <Box sx={{
            width: '100%',
            display: 'flex',
            flexWrap: 'nowrap',
            justifyContent: 'space-between',
          }}>
            <Typography variant="h5" marked="center">
              Players
            </Typography>
            <Tooltip title="Reload">
              <IconButton onClick={() => addToLoading(fetchInitialRecentPlayers())}>
                <RefreshIcon color="inherit" sx={{display: 'block'}}/>
              </IconButton>
            </Tooltip>
          </Box>
        </Toolbar>
      </AppBar>

      <List aria-label="secondary mailbox folder">
        {recentPlayers && recentPlayers.map((recentPlayer, i) => {
          return (
            <ListItemButton
              key={recentPlayer.displayName}
              selected={i === selectedPlayerIndex}
              onClick={(event) => handlePlayerListItemClick(event, i)}
            >
              <ListItemText primary={`${recentPlayer.displayName} (${recentPlayer.initials})`}/>
            </ListItemButton>
          );
        })}
        {loadedRecentPlayerPages < maxRecentPlayerPages &&
          <ListItemButton
            onClick={() => addToLoading(fetchMoreRecentPlayers())}
          >
            <ListItemText
              primaryTypographyProps={{style: {fontWeight: 100}}}
              primary={`Load more...`}
            />
          </ListItemButton>
        }

      </List>
    </Paper>
  );
}
RecentPlayers.propTypes = {
  onSelected: PropTypes.func,
};
